import React from "react";
import PropTypes from "prop-types";
import {ACheckbox} from "@cisco-sbg-ui/magna-react";

const IncidentTableCheckbox = ({checked, disabled, handleClick}) => (
  <ACheckbox
    data-testid={"IncidentTableCheckbox-Checkbox"}
    className="incident-table-checkbox"
    checked={checked}
    disabled={disabled}
    onClick={() => !disabled && handleClick()}
  />
);

IncidentTableCheckbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func
};

export default IncidentTableCheckbox;
